<div class="product-functionkeys-expression-component" [ngClass]="{ 'dx-rtl': rtlEnabled }" dir="{{rtlEnabled ? 'rtl' : 'ltr'}}">
    <dx-popup #addProductFunctionkeyExpression [width]="600" [showTitle]="true" title="{{ modalTitle }}"
        [dragEnabled]="false" [closeOnOutsideClick]="false" [rtlEnabled]="rtlEnabled" [(visible)]="isOpened"
        (onShown)="onFieldDataChanged($event)">
        <dx-scroll-view width="100%" height="100%">
            <div class="au-dx-popup-padder">
                <dx-form #productFunctionkeysExpressionForm id="productFunctionkeysExpressionForm"
                    validationGroup="productFunctionkeysExpressionData" [showValidationSummary]="false"
                    (onFieldDataChanged)="onFieldDataChanged($event)" colCount="auto" [(formData)]="model"
                    [minColWidth]="500">

                    <dxi-item itemType="group">
                        <dxi-item dataField="name">
                            <dxo-label text="{{ 'SHARED.NAME' | translate }}"></dxo-label>
                            <dxi-validation-rule type="required"
                                message="{{ 'SHARED.NAME' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}">
                            </dxi-validation-rule>
                        </dxi-item>

                        <dxi-item dataField="productPropertyId" editorType="dxSelectBox"
                            [editorOptions]="{ items: productProperties, valueExpr:'productPropertyId', displayExpr:'name'}">
                            <dxo-label text="{{ 'PRODUCT.PROPERTY_NAME' | translate }}"></dxo-label>
                            <dxi-validation-rule type="required" message="{{ 'PRODUCT.PROPERTY_NAME' | translate }}">
                            </dxi-validation-rule>
                        </dxi-item>

                        <dxi-item dataField="expression" editorType="dxTextArea">
                            <dxo-label
                                text="{{ 'PRODUCT.FUNCTIONKEYS_EXPRESSION.EXPRESSION' | translate }}"></dxo-label>
                            <dxi-validation-rule type="required"
                                message="{{ 'PRODUCT.FUNCTIONKEYS_EXPRESSION.EXPRESSION' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}">
                            </dxi-validation-rule>
                        </dxi-item>

                      <dxi-item dataField="usableDuringClockRun" editorType="dxCheckBox">
                            <dxo-label
                                text="{{ 'PRODUCT.FUNCTIONKEYS_EXPRESSION.USABLE_DURING_CLOCK_RUN' | translate }}"></dxo-label>
                        </dxi-item>
                        
                      <dxi-item dataField="useDefaultValueFromLot" editorType="dxCheckBox">
                        <dxo-label
                            text="{{ 'PRODUCT.FUNCTIONKEYS_EXPRESSION.USE_DEFAULT_VALUE' | translate }}"></dxo-label>
                    </dxi-item>
                    </dxi-item>
                </dx-form>
                <button type="submit" class="btn btn-primary" (click)="onSubmit();"
                    name="btnProductFunctionkeysExpressionSubmit" disabled="disabled">{{ 'SHARED.SAVE' | translate
                    }}</button>
                <button type="button" class="btn btn-outline" (click)="onCancel();">{{ 'SHARED.CANCEL' | translate
                    }}</button>

            </div>
        </dx-scroll-view>
    </dx-popup>
</div>
